<!-- 悬浮球 class="animate__animated animate__wobble" -->

<template>
  <div :class="['levitated-container', displayModeClassName]" v-show="showBox">
    <div
      :class="[
        'box',
        { display: showBox ? 'block' : 'none', red_point: showRedPoint },
        showBoxAnimation ? ['animate__animated', 'animate__bounceIn'] : '',
      ]"
      @click="handleClickBox"
    >
      <img
        :class="[
          'animate__animated',
          'animate__wobble',
          wobbleSignal ? 'active' : '',
        ]"
        v-lazy="require(`@/assets/images/detail/box-gift.png`)"
        alt="gift-icon"
      />
      <p
        class="activity_desc"
        :style="{ display: `${showActivityDesc ? 'block' : 'none'}` }"
      >
        活动福利
      </p>
    </div>
  </div>
</template>

<script>
  // import "animate.css"
  import { mapState, mapGetters } from 'vuex'
  import {
    trackFloatBoxShow,
    trackFloatBoxClick,
  } from '../CloudControlPopup/firebase'

  export default {
    name: 'levitated-sphere',
    props: {
      id: String,
      showRedTip: Boolean, //是否展示小红点
      showBox: Boolean, //是否展示悬浮盒子
    },
    data() {
      return {
        showBoxAnimation: true, // 是否展示悬浮盒子出现的动画
        wobbleSignal: false,
        showActivityDesc: false,
        showRedPoint: this.showRedTip,
        timeMap: {},
        timerId: 0,
      }
    },
    computed: {
      ...mapState(['gameName']),
      ...mapGetters(['displayModeClassName']),
    },
    watch: {
      showRedTip() {
        this.showRedPoint = this.showRedTip
      },
      showBox(val) {
        if (val) {
          trackFloatBoxShow({
            page: this.gameName,
            assignment_id: this.id,
          })
        }
      },
    },
    created() {
      if (!process.client) return

      // 每隔4s就摇晃悬浮盒子(传递的时间取目标间隔时间的一半)
      const TIME_INTERVAL = 2 // 单位为秒
      this.mySetInterval(this.animationHandler, TIME_INTERVAL * 1000)
    },
    beforeDestroy() {
      this.myClearInterval(this.timerId)
    },
    methods: {
      animationHandler() {
        this.wobbleSignal = !this.wobbleSignal
        // console.log('wobbleSignal: ',this.wobbleSignal)
      },
      mySetInterval(cb, time) {
        const self = this
        let timeId = this.timerId
        this.timerId++ // 自增实现唯一id
        function fn() {
          // console.log(time/1000 + 's have passed...')
          cb()
          self.timeMap[timeId] = setTimeout(() => {
            fn()
          }, time)
        }
        this.timeMap[timeId] = setTimeout(fn, time)
        return timeId
      },
      myClearInterval(timerId) {
        clearTimeout(this.timeMap[timerId])
        delete this.timeMap[timerId]
      },
      handleClickBox() {
        trackFloatBoxClick({
          page: this.gameName,
          assignment_id: this.id,
        })
        const type = 1
        this.$emit('displayPopup', type)
      },
    },
  }
</script>

<style lang="scss">
  /* @keyframes duration | timing-function | delay |
   iteration-count | direction | fill-mode | play-state | name */
  .animate__animated.animate__wobble {
    &.active {
      animation: 0.8s 1 alternate both activeAnimation;
      // animation-duration: 1.5s;
      // animation-iteration-count: 1;
      // animation-direction: alternate;
      // animation-fill-mode: both;
      // animation-name: activeAnimation;
    }
  }

  .levitated-container {
    position: fixed;
    right: 48px;
    bottom: 355px;
    width: 200px;
    height: 200px;
    box-sizing: border-box;
    border-radius: 50%;
    z-index: 2;

    .box {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 200px;
        height: 200px;
        object-fit: contain;
      }
      &.red_point::after {
        content: '';
        position: absolute;
        top: 20px;
        right: 20px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: red;
        visibility: hidden; // 应产品需求变更，本期不显示红点
      }

      .activity_desc {
        width: 200px;
        height: 80px;
        position: absolute;
        left: 0;
        bottom: -20px;
        background-color: #fff;
        border-radius: 15px;
        text-align: center;
      }
    }

    &.display-desktop {
      width: 100px;
      height: 100px;
      right: 50px;
      bottom: 50px;
      .box {
        img {
          width: 87px;
          height: 87px;
        }
      }
    }
  }

  @keyframes activeAnimation {
    0% {
      transform: rotate(0deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    10% {
      transform: rotate(-12deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    20% {
      transform: rotate(12deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    28% {
      transform: rotate(-10deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    36% {
      transform: rotate(10deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    42% {
      transform: rotate(-8deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    48% {
      transform: rotate(8deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    52% {
      transform: rotate(-4deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    56% {
      transform: rotate(4deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    60% {
      transform: rotate(0deg);
      transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    }

    75% {
      transform: rotate(0deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    100% {
      transform: rotate(0deg);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
</style>
